module.exports = __webpack_public_path__ + "img/archi.8f1e334c.png";